var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGreen7206D48Ad23C73E3Bc352F4E840Ba2Fe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_2941)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 6C19.4315 6 6 19.4315 6 36C6 52.5685 19.4315 66 36 66C52.5685 66 66 52.5685 66 36C66 19.4315 52.5685 6 36 6ZM0 36C0 16.1177 16.1177 0 36 0C55.8823 0 72 16.1177 72 36C72 55.8823 55.8823 72 36 72C16.1177 72 0 55.8823 0 36ZM37.4281 15.4999L37.546 15.5C39.558 15.5 41.9422 16.1634 43.8526 17.9002C45.8224 19.6908 47.046 22.4016 47.046 26C47.046 32.025 43.0343 34.7629 41.2995 35.9468C41.0257 36.1337 40.8086 36.2819 40.6729 36.3982C38.4634 38.2921 38.5059 40.6187 38.5385 42.4034C38.5423 42.61 38.546 42.8094 38.546 43C38.546 44.3807 37.4267 45.5 36.046 45.5C34.6652 45.5 33.546 44.3807 33.546 43C33.546 42.8966 33.5407 42.7602 33.5344 42.5947C33.4694 40.8978 33.2874 36.1433 37.419 32.6019C37.8891 32.1989 38.367 31.8512 38.8284 31.5155C40.5521 30.2613 42.046 29.1743 42.046 26C42.046 23.5984 41.2695 22.3092 40.4893 21.5999C39.6498 20.8367 38.5339 20.5 37.546 20.5C35.4876 20.5 33.1469 20.584 31.4665 22.6005C30.5826 23.6612 29.0062 23.8045 27.9455 22.9206C26.8848 22.0367 26.7415 20.4602 27.6254 19.3996C30.8796 15.4945 35.4213 15.4983 37.4281 15.4999ZM39 51C39 49.3431 37.6569 48 36 48C34.3431 48 33 49.3431 33 51V52.5C33 54.1569 34.3431 55.5 36 55.5C37.6569 55.5 39 54.1569 39 52.5V51Z",
    fill: "#2DC8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 6C19.4315 6 6 19.4315 6 36C6 52.5685 19.4315 66 36 66C52.5685 66 66 52.5685 66 36C66 19.4315 52.5685 6 36 6ZM0 36C0 16.1177 16.1177 0 36 0C55.8823 0 72 16.1177 72 36C72 55.8823 55.8823 72 36 72C16.1177 72 0 55.8823 0 36ZM37.4281 15.4999L37.546 15.5C39.558 15.5 41.9422 16.1634 43.8526 17.9002C45.8224 19.6908 47.046 22.4016 47.046 26C47.046 32.025 43.0343 34.7629 41.2995 35.9468C41.0257 36.1337 40.8086 36.2819 40.6729 36.3982C38.4634 38.2921 38.5059 40.6187 38.5385 42.4034C38.5423 42.61 38.546 42.8094 38.546 43C38.546 44.3807 37.4267 45.5 36.046 45.5C34.6652 45.5 33.546 44.3807 33.546 43C33.546 42.8966 33.5407 42.7602 33.5344 42.5947C33.4694 40.8978 33.2874 36.1433 37.419 32.6019C37.8891 32.1989 38.367 31.8512 38.8284 31.5155C40.5521 30.2613 42.046 29.1743 42.046 26C42.046 23.5984 41.2695 22.3092 40.4893 21.5999C39.6498 20.8367 38.5339 20.5 37.546 20.5C35.4876 20.5 33.1469 20.584 31.4665 22.6005C30.5826 23.6612 29.0062 23.8045 27.9455 22.9206C26.8848 22.0367 26.7415 20.4602 27.6254 19.3996C30.8796 15.4945 35.4213 15.4983 37.4281 15.4999ZM39 51C39 49.3431 37.6569 48 36 48C34.3431 48 33 49.3431 33 51V52.5C33 54.1569 34.3431 55.5 36 55.5C37.6569 55.5 39 54.1569 39 52.5V51Z",
    fill: "url(#paint0_linear_272_2941)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_2941",
    x1: 56.1232,
    y1: -100.051,
    x2: -75.1252,
    y2: 6.37578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206376,
    stopColor: "#FFF0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359714,
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833386,
    stopColor: "#FF41F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF33FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_2941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGreen7206D48Ad23C73E3Bc352F4E840Ba2Fe);
export default __webpack_public_path__ + "static/media/circle-green.7206d48ad23c73e3bc352f4e840ba2fe.97b32f0b4e9d17c0a7df47589a1ef37d.svg";
export { ForwardRef as ReactComponent };